import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationTimeline } from "web_myplann/Inspiration/Components/InspirationTimeline";
import { RetirementAgeSection } from "web_myplann/Inspiration/Retirement/Components/RetirementAgeSection";
import { RetirementCapitalSection } from "web_myplann/Inspiration/Retirement/Components/RetirementCapitalSection";
import { RetirementExpensesSection } from "web_myplann/Inspiration/Retirement/Components/RetirementExpensesSection";
import { RetirementPaceSection } from "web_myplann/Inspiration/Retirement/Components/RetirementPaceSection";
import { RetirementStateSection } from "web_myplann/Inspiration/Retirement/Components/RetirementStateSection";
import { RetirementTargetSection } from "web_myplann/Inspiration/Retirement/Components/RetirementTargetSection";
import { RETIREMENT_PHASES } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementSheet } from "web_myplann/Inspiration/Retirement/Hooks/useRetirementJourney";
import type {
	RetirementContext,
	RetirementInputs,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

type Props = {
	context: RetirementContext;
	patchInputs: (patch: Partial<RetirementInputs>) => void;
	openSheet: (sheet: RetirementSheet) => void;
	toggleDrop: (id: string) => void;
	removeManualDrop: (id: string) => void;
};

export const RetirementResult: FC<Props> = ({
	context,
	patchInputs,
	openSheet,
	toggleDrop,
	removeManualDrop,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack mt={theme.spacingTokens.sm} gap={theme.spacingTokens.sm}>
			<RetirementAgeSection
				context={context}
				onChangeAge={(retirementAge) => patchInputs({ retirementAge })}
			/>
			<RetirementExpensesSection
				context={context}
				onToggleDrop={toggleDrop}
				onRemoveDrop={removeManualDrop}
				onAddLoan={() => openSheet("addLoan")}
			/>
			<RetirementTargetSection
				context={context}
				onChangeIncome={(desiredIncome) => patchInputs({ desiredIncome })}
			/>
			<RetirementStateSection
				context={context}
				onEdit={() => openSheet("statePension")}
			/>
			<RetirementCapitalSection
				context={context}
				onChangeDrawdownMode={(drawdownMode) => patchInputs({ drawdownMode })}
			/>
			{!context.isCoveredByState && (
				<>
					<RetirementPaceSection
						context={context}
						onChangeContribution={(monthlyContribution) =>
							patchInputs({ monthlyContribution })
						}
						onSelectScenario={(scenario) => patchInputs({ scenario })}
					/>
					<InspirationTimeline
						title={t(Resources.Inspiration.Retirement.phasesTitle)}
						steps={RETIREMENT_PHASES}
					/>
				</>
			)}
		</Stack>
	);
};
